import React from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const location = useLocation();
  const order = location.state || {};

  if (!order.orderNumber) {
    return (
      <main className="order-success">
        <section
          className="order-success__card"
          aria-labelledby="order-success-empty-title"
        >
          <p className="order-success__eyebrow">No active order</p>
          <h1 id="order-success-empty-title">Nothing to confirm yet.</h1>
          <p className="order-success__message">
            Complete the demo checkout first and your order confirmation will
            appear here.
          </p>
          <div className="order-success__actions">
            <Link
              to="/shop"
              className="order-success__button order-success__button--dark"
            >
              Shop the collection
            </Link>
            <Link to="/cartpage" className="order-success__button">
              View cart
            </Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="order-success">
      <section className="order-success__card" aria-labelledby="order-success-title">
        <div className="order-success__mark" aria-hidden="true">
          <svg viewBox="0 0 48 48" role="presentation">
            <path d="m14 25 7 7 14-16" />
          </svg>
        </div>
        <p className="order-success__eyebrow">Order received</p>
        <h1 id="order-success-title">Thank you.</h1>
        <p className="order-success__message">
          Your order is confirmed. We will send an email when your{" "}
          {siteConfig.brandName} pieces are packed and on their way.
        </p>

        {(order.orderNumber || order.email) && (
          <dl className="order-success__details">
            {order.orderNumber && (
              <div>
                <dt>Order</dt>
                <dd>{order.orderNumber}</dd>
              </div>
            )}
            {order.email && (
              <div>
                <dt>Confirmation sent to</dt>
                <dd>{order.email}</dd>
              </div>
            )}
            {Number.isFinite(order.total) && (
              <div>
                <dt>Total</dt>
                <dd>
                  {siteConfig.currency.symbol}{Number(order.total).toFixed(2)}{" "}
                  {siteConfig.currency.code}
                </dd>
              </div>
            )}
          </dl>
        )}

        <div className="order-success__timeline" aria-label="What happens next">
          <div>
            <span>01</span>
            <p>Confirmation</p>
            <small>Check your inbox for the order details.</small>
          </div>
          <div>
            <span>02</span>
            <p>Packing</p>
            <small>Most orders are prepared in 1–2 business days.</small>
          </div>
          <div>
            <span>03</span>
            <p>Tracking</p>
            <small>A tracking link arrives as soon as the parcel leaves.</small>
          </div>
        </div>

        <div className="order-success__actions">
          <Link to="/shop" className="order-success__button order-success__button--dark">
            Continue shopping
          </Link>
          <Link to="/contact" className="order-success__button">
            Get order help
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
